module.exports = __webpack_public_path__ + "fonts/e5739f8d4d092cdc4742eef29bb01968.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/file_pdf_white.svg
// module id = 2031
// module chunks = 0